import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
    fontSize: 16,
    h1: {
      fontSize: 36,
      color: '#CF1F38',
      fontWeight: '900',
      fontFamily: 'Playfair Display, serif',
    },
    body1: {
      fontSize: 14,
      color: '#000000',
      fontFamily: 'Open Sans, sans-serif',
    },
  },
  palette: {
    primary: {
      main: '#CF1F38',
    },
    secondary: {
      main: '#36659C',
    },
    success: {
      main: '#298936',
    },
    textcolor: {
      main: '#5C5C5C',
    },
    background: {
      main: '#FAFAF6',
      dark: '#F5EFD9',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '[data-key="tooltip"]': {
          padding: '0 !important',
          zIndex: 1000,
        },
        '#swarmViz': {
          '& .pic-tooltip-content': {

            '& td:nth-child(8)': {
              borderRight: '1px solid #707070',
            },
            '& td:nth-child(9)': {
              borderRight: '1px solid #707070',
            },
            '& tr:nth-child(7)': {
              borderTop: '1px solid #707070',
            },
            '& tr:nth-child(8)': {
              borderTop: '1px solid #707070',
            },
          },
        },
        '.pic-tooltip-content': {
          backgroundColor: '#FFFFFF !important',
          padding: '0px !important',
          margin: '0 !important',
          border: '1px solid #707070 !important',
          borderRadius: '3px !important',
          color: '#5C5C5C !important',
          fontFamily: 'Source Sans Pro, sans-serif !important',
          opacity: '1 !important',
          borderCollapse: 'collapse',
        },
        '.pic-tooltip-arrow': {
          color: '#FFFFFF !important',
          opacity: '1 !important',
        },
      },
    },
  },
});

export default theme;
